module.exports = __webpack_public_path__ + "assets/img/icon-moto-blue.5c7ad5d6.png";